import React, { useEffect, useState } from 'react';
import { Table, TableContainer, TableCell, TableHead, TableRow, TableBody, Container, Card, Button, Box, Typography, Paper } from '@mui/material';
import axios from 'axios';
import * as XLSX from 'xlsx';
import AppNavbar from './AdminNav';
import useAuth from './Auth'; 
import './LeadPage.css';

const UserContactDetails = () => {
  const isAuth = useAuth(); 
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isAuth) {
      const fetchLeads = async () => {
        try {
          const response = await axios.get('https://backend.thegameofthemoney.com/admin/getLeads', {
            headers: {
              'Content-Type': 'application/json',
              'access-key': 'ASDFGHJ23456$^%$*&dhsjdhshLMKNGBHGsjdgash23bsh'
            }
          });

          setLeads(response.data.requestData);
          setLoading(false);
        } catch (error) {
          setError(error.response ? error.response.data.message : error.message);
          setLoading(false);
        }
      };

      fetchLeads();
    }
  }, [isAuth]);

  const exportToExcel = () => {
    const fileName = 'LeadDetails.xlsx';
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

    const formattedData = leads.map((lead, index) => ({
      Sno: index + 1,
      Name: lead.name,
      Email: lead.email,
      'Contact Number': lead.contact,
      Reason: lead.reason,
      Message: lead.message,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    const url = URL.createObjectURL(data);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (!isAuth) {
    return null; 
  }

  return (
    <div className="user-contact-details">
      <AppNavbar />
      <Container maxWidth="xl" sx={{ mt: 5, pt: 5, pb: 5 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Card sx={{ width: '100%', padding: 3, minHeight: '520px' }}> 
            <Typography variant="h4" align="center" gutterBottom>Lead Details</Typography>
            <Box sx={{ overflowX: 'auto' }}>
              <TableContainer component={Paper} sx={{ backgroundColor: 'transparent' }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', border: 1 }}>Sno</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', border: 1 }}>Name</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', border: 1 }}>Email</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', border: 1 }}>Contact Number</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', border: 1 }}>Message</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={5} style={{ textAlign: 'center' }}>Loading...</TableCell>
                      </TableRow>
                    ) : error ? (
                      <TableRow>
                        <TableCell colSpan={5} style={{ textAlign: 'center', color: 'red' }}>Error: {error}</TableCell>
                      </TableRow>
                    ) : leads.length > 0 ? (
                      leads.map((lead, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ border: 1 }}>{index + 1}</TableCell>
                          <TableCell sx={{ border: 1 }}>{lead.name}</TableCell>
                          <TableCell sx={{ border: 1 }}>{lead.email}</TableCell>
                          <TableCell sx={{ border: 1 }}>{lead.contact}</TableCell>
                          <TableCell sx={{ border: 1 }}>{lead.message}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} style={{ textAlign: 'center' }}>No leads available</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button variant="contained" color="success" onClick={exportToExcel}>
                Export to Excel
              </Button>
            </Box>
          </Card>
        </Box>
      </Container>
    </div>
  );
};

export default UserContactDetails;
